/**
 * Calendar Ending Trigger Component
 *
 * Trigger: "calendar ending soon"
 * No additional fields needed - timing is handled at card level.
 */

import { FC } from 'react';
import { useTranslation } from 'react-i18next';

import { TriggerComponentProps } from '../automationTriggers';

export const CalendarEndingTrigger: FC<TriggerComponentProps> = ({
  readOnly,
}) => {
  const { t } = useTranslation();

  if (readOnly) {
    return <span>{t('automations.triggers.calendarEnding')}</span>;
  }

  // Edit mode - no additional fields, timing handled at card level
  return null;
};
